import axios from 'axios';
import { toast } from 'react-toastify';
import { push } from 'connected-react-router';

// URIs
import serverURI from '../../config/URI';
// Helpers
import errorHandler from '../helpers/errorHandler';

//import { getParties } from './party';


export const LOADING_STATISTICS = () => ({ type: 'LOADING_STATISTICS', });
export const LOADING_STATISTICS_SUCCESS = () => ({ type: 'LOADING_STATISTICS_SUCCESS', });
export const LOADING_STATISTICS_ERROR = () => ({ type: 'LOADING_STATISTICS_ERROR', });

export const ADDING_STATISTIC = () => ({ type: 'ADDING_STATISTIC', });
export const ADDING_STATISTIC_SUCCESS = () => ({ type: 'ADDING_STATISTIC_SUCCESS', });
export const ADDING_STATISTIC_ERROR = () => ({ type: 'ADDING_STATISTIC_ERROR', });

export const UPDATING_STATISTIC = () => ({ type: 'UPDATING_STATISTIC', });
export const UPDATING_STATISTIC_SUCCESS = () => ({ type: 'UPDATING_STATISTIC_SUCCESS', });
export const UPDATING_STATISTIC_ERROR = () => ({ type: 'UPDATING_STATISTIC_ERROR', });

export const DELETING_STATISTIC = () => ({ type: 'DELETING_STATISTIC', });
export const DELETING_STATISTIC_SUCCESS = () => ({ type: 'DELETING_STATISTIC_SUCCESS', });
export const DELETING_STATISTIC_ERROR = () => ({ type: 'DELETING_STATISTIC_ERROR', });


export const FINDING_ADVERTISE_LOGS = () => ({ type: 'FINDING_ADVERTISE_LOGS', });
export const FINDING_ADVERTISE_LOGS_SUCCESS = () => ({ type: 'FINDING_ADVERTISE_LOGS_SUCCESS', });
export const FINDING_ADVERTISE_LOGS_ERROR = () => ({ type: 'FINDING_ADVERTISE_LOGS_ERROR', });

export const DELETING_ADVERTISE_LOGS = () => ({ type: 'DELETING_ADVERTISE_LOGS', });
export const DELETING_ADVERTISE_LOGS_SUCCESS = () => ({ type: 'DELETING_ADVERTISE_LOGS_SUCCESS', });
export const DELETING_ADVERTISE_LOGS_ERROR = () => ({ type: 'DELETING_ADVERTISE_LOGS_ERROR', });

export const FINDING_TAXI_LOGS = () => ({ type: 'FINDING_TAXI_LOGS', });
export const FINDING_TAXI_LOGS_SUCCESS = () => ({ type: 'FINDING_TAXI_LOGS_SUCCESS', });
export const FINDING_TAXI_LOGS_ERROR = () => ({ type: 'FINDING_TAXI_LOGS_ERROR', });

export const DELETING_TAXI_LOGS = () => ({ type: 'DELETING_TAXI_LOGS', });
export const DELETING_TAXI_LOGS_SUCCESS = () => ({ type: 'DELETING_TAXI_LOGS_SUCCESS', });
export const DELETING_TAXI_LOGS_ERROR = () => ({ type: 'DELETING_TAXI_LOGS_ERROR', });

export const FINDING_CLIENT_LOGS = () => ({ type: 'FINDING_CLIENT_LOGS', });
export const FINDING_CLIENT_LOGS_SUCCESS = () => ({ type: 'FINDING_CLIENT_LOGS_SUCCESS', });
export const FINDING_CLIENT_LOGS_ERROR = () => ({ type: 'FINDING_CLIENT_LOGS_ERROR', });


export const getStatistics = (dispatch) => {
  dispatch({ type: LOADING_STATISTICS });

  axios
    .get(`${serverURI}/api/statistic/all`)
    .then((res) => {
      dispatch({
        type: LOADING_STATISTICS_SUCCESS,
        payload: res.data.statistics
      });
    })
    .catch((err) => {
      dispatch({ type: LOADING_STATISTICS_ERROR, payload: err });
      errorHandler(err);
    });
};


export const addStatistic = (statistic, dispatch) => {
  dispatch({ type: ADDING_STATISTIC });

  axios
    .post(`${serverURI}/api/statistic/add`, statistic)
    .then((res) => {
      //console.log(res);
      dispatch({ type: ADDING_STATISTIC_SUCCESS, 
        payload: res.data.statistic, 
        });
    })
    .catch((err) => {
      dispatch({ type: ADDING_STATISTIC_ERROR, payload: err });
      errorHandler(err);
    });
};

export const updateStatistic = (id, statistic, dispatch) => {
  dispatch({ type: UPDATING_STATISTIC });

  axios
    .put(`${serverURI}/api/statistic/update/${id}`, statistic)
    .then((res) => {
      //console.log(res);
      dispatch({ type: UPDATING_STATISTIC_SUCCESS, 
        payload: res.data.statistic, 
        });
    })
    .catch((err) => {
      dispatch({ type: UPDATING_STATISTIC_ERROR, payload: err });
      errorHandler(err);
    });
};

export const deleteStatistic = (deletes, dispatch) => {
  dispatch({ type: DELETING_STATISTIC });

  const deleteData = {
    deletes: deletes,
  };

  return axios
    .delete(`${serverURI}/api/statistic/delete`, {data: deleteData})
    .then((res) => {
      //console.log(res);
      dispatch({ type: DELETING_STATISTIC_SUCCESS, 
        payload: res.data.deletedStatistics, 
        });
    })
    .catch((err) => {
      dispatch({ type: DELETING_STATISTIC_ERROR, payload: err });
      errorHandler(err);
    });
};






export const findAdvertiseLogs = (find, dispatch) => {
  dispatch({ type: FINDING_ADVERTISE_LOGS });

  axios
    .post(`${serverURI}/api/statistics/advertise/find`, find)
    .then((res) => {
      //console.log(res);
      dispatch({ type: FINDING_ADVERTISE_LOGS_SUCCESS, 
        payload: {
          find_total: res.data.total,
          find_logs: res.data.logs, 
        },
      });
    })
    .catch((err) => {
      dispatch({ type: FINDING_ADVERTISE_LOGS_ERROR, payload: err });
      errorHandler(err);
    });
};

export const removeAdvertiseLogs = (dispatch) => {
  dispatch({ type: FINDING_ADVERTISE_LOGS_SUCCESS, 
    payload: {
      find_total: 0,
      find_logs: [], 
    },
  });
};


export const deleteAllAdvertiseLogs = (deleteDate, dispatch) => {
  dispatch({ type: DELETING_ADVERTISE_LOGS });

  const deleteData = {
    deleteDate: deleteDate,
  };

  return axios
    .delete(`${serverURI}/api/statistics/advertise/delete`, {data: deleteData})
    .then((res) => {
      //console.log(res);
      dispatch({ type: DELETING_ADVERTISE_LOGS_SUCCESS, 
        payload: [], 
        });
    })
    .catch((err) => {
      dispatch({ type: DELETING_ADVERTISE_LOGS_ERROR, payload: err });
      errorHandler(err);
    });
};




export const findTaxiLogs = (find, dispatch) => {
  dispatch({ type: FINDING_TAXI_LOGS });

  axios
    .post(`${serverURI}/api/statistics/taxi/find`, find)
    .then((res) => {
      //console.log(res);
      dispatch({ type: FINDING_TAXI_LOGS_SUCCESS, 
        payload: {
          find_total: res.data.total,
          find_logs: res.data.logs, 
        },
      });
    })
    .catch((err) => {
      dispatch({ type: FINDING_TAXI_LOGS_ERROR, payload: err });
      errorHandler(err);
    });
};

export const removeTaxiLogs = (dispatch) => {
  dispatch({ type: FINDING_TAXI_LOGS_SUCCESS, 
    payload: {
      find_total: 0,
      find_logs: [], 
    },
  });
};

export const deleteAllTaxiLogs = (deleteDate, dispatch) => {
  dispatch({ type: DELETING_TAXI_LOGS });

  const deleteData = {
    deleteDate: deleteDate,
  };

  return axios
    .delete(`${serverURI}/api/statistics/advertise/delete`, {data: deleteData})
    .then((res) => {
      //console.log(res);
      dispatch({ type: DELETING_TAXI_LOGS_SUCCESS, 
        payload: [], 
        });
    })
    .catch((err) => {
      dispatch({ type: DELETING_TAXI_LOGS_ERROR, payload: err });
      errorHandler(err);
    });
};

export const findClientLogs = (find, dispatch) => {
  dispatch({ type: FINDING_CLIENT_LOGS });

  axios
    .post(`${serverURI}/api/statistics/client/find`, find)
    .then((res) => {
      //console.log(res);
      dispatch({ type: FINDING_CLIENT_LOGS_SUCCESS, 
        payload: {
          find_total: res.data.total,
          find_logs: res.data.logs, 
        },
      });
    })
    .catch((err) => {
      dispatch({ type: FINDING_CLIENT_LOGS_ERROR, payload: err });
      errorHandler(err);
    });
};
